const NORMAL_STOP_REASONS = new Set([
  'local',
  'remote',
  'evdisconnected',
  'deauthorized',
  'hardreset',
  'softreset',
  'powerloss',
  'reboot',
  'unlockcommand',
]);

export function isAbnormalOcppStopReason(reason) {
  if (!reason || !String(reason).trim()) {
    return false;
  }
  return !NORMAL_STOP_REASONS.has(String(reason).trim().toLowerCase());
}

/**
 * Build detail string for the red "station stopped charging" banner.
 * Prefer StatusNotification.errorInfo (vendor text) when present.
 * Returns null when there is nothing abnormal to show.
 */
export function formatOcppStopDetail({ ocppErrorCode, ocppErrorInfo, ocppStopReason } = {}) {
  const errorInfo = ocppErrorInfo && String(ocppErrorInfo).trim();
  const errorCode = ocppErrorCode && String(ocppErrorCode).trim();
  const stopReason = ocppStopReason && String(ocppStopReason).trim();

  if (errorInfo) {
    if (errorCode) {
      return `${errorInfo} (${errorCode})`;
    }
    return errorInfo;
  }
  if (errorCode) {
    if (stopReason) {
      return `${errorCode} (${stopReason})`;
    }
    return errorCode;
  }
  if (stopReason && isAbnormalOcppStopReason(stopReason)) {
    return stopReason;
  }
  return null;
}
